import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { StoreProvider } from "@/context/StoreContext";
import { CustomerProvider } from "@/context/CustomerContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import Checkout from "@/pages/Checkout";
import TrackOrder from "@/pages/TrackOrder";
import GiftFinder from "@/pages/GiftFinder";

const StoreLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <WhatsAppButton />
    <CartDrawer />
  </>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CustomerProvider>
          <StoreProvider>
            <CartProvider>
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<StoreLayout><Home /></StoreLayout>} />
                  <Route path="/shop" element={<StoreLayout><Shop /></StoreLayout>} />
                  <Route path="/product/:id" element={<StoreLayout><ProductDetail /></StoreLayout>} />
                  <Route path="/account" element={<StoreLayout><Account /></StoreLayout>} />
                  <Route path="/checkout" element={<StoreLayout><Checkout /></StoreLayout>} />
                  <Route path="/track" element={<StoreLayout><TrackOrder /></StoreLayout>} />
                  <Route path="/gift-finder" element={<StoreLayout><GiftFinder /></StoreLayout>} />
                  <Route path="/admin" element={<Admin />} />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-center" richColors />
            </CartProvider>
          </StoreProvider>
        </CustomerProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
